import { Component, OnInit, input, signal } from '@angular/core';

import { Subject } from 'rxjs';

import { FormComponent } from '@camelot/form-basic';
import { CamAbstractInput } from '@camelot/form-model';
import { FontIconComponent } from '@camelot/icons';
import { TranslatePipe } from '@camelot/translation';
import { BadgeComponent, ButtonComponent, CardComponent, CardContentComponent } from '@camelot/ui';

import { CamTranslationCore } from '../../../../translation.service';
import { IPreFilter } from '../../models/types';
import { AbstractGridComponent } from '../abstract-grid.component';

@Component({
  selector: 'cam-grid-highlight-filter',
  templateUrl: './grid-highlight-filter.component.html',
  styleUrl: './grid-highlight-filter.component.scss',
  imports: [
    BadgeComponent,
    ButtonComponent,
    CardComponent,
    CardContentComponent,
    FontIconComponent,
    FormComponent,
    TranslatePipe,
  ],
})
export class GridHighlightFilterComponent extends AbstractGridComponent<any> implements OnInit {
  liveFilter = input(false);

  preFilters = input<IPreFilter[]>([]);

  showClearButton = input(true);

  public activePreFilter: IPreFilter | null = null;
  public askValidation$ = new Subject<null>();
  public readonly highlightForm = signal<CamAbstractInput[]>([]);

  constructor() {
    super();
    CamTranslationCore.getInstance();
  }

  override ngOnInit() {
    super.ngOnInit();
    if (this._grid.isReady()) {
      this.setHighlightForm();
    } else {
      this._registerSubscription(this._grid.ready$.subscribe(() => this.setHighlightForm()));
    }
    this._registerSubscription(this._grid.filters.filtersChanged$.subscribe(() => this.setHighlightForm()));
  }

  public setHighlightForm() {
    this.highlightForm.set(this._grid.getHighlightFiltersForm());
  }

  public filtersSelected(data: any) {
    this._grid.filters.applyFiltersForm(data);
    this.activePreFilter = null;
    this.setHighlightForm();
  }

  public selectPreFilter(preFilter: IPreFilter) {
    if (this.activePreFilter === preFilter) {
      this.activePreFilter = null;
      this._grid.filters.applyFiltersForm(null);
    } else {
      this.activePreFilter = preFilter;
      this._grid.filters.applyFiltersForm(preFilter.data);
    }
    this.setHighlightForm();
  }

  public clear() {
    this.activePreFilter = null;
    this._grid.filters.applyFiltersForm(null);
    this.setHighlightForm();
  }

  public submit() {
    this.askValidation$.next(null);
  }
}
